import React, { Component } from 'react'
import { connect } from 'react-redux'
import { updateFillValue, updateFillAnswer, setWeightData } from '../actions/index'

var $ = window.$

class Weight extends Component {
  state = {
    units:'',
    grams:'',
    kg:'',
    lbs:'',
    oz:''
  }
  componentDidMount() {
    var self = this;
    $(this.$el)
      .find('.chosen-select-no-single')
      .chosen({disable_search_threshold:100})
      .change(function() {
        self.setState((state) => {
          return {
            units: $(this).val()
          }
        })
      });
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state !== prevState) {
      var gPerLb = 453.5924;
      switch(this.state.units) {
        case 'imperial':
          this.setgrams(Math.round(gPerLb * (1*this.state.lbs + (1*this.state.oz/16))));
          this.setkg(1*this.state.grams/1000);
          this.props.dispatch(updateFillAnswer(this.state.lbs + ' lbs / ' + this.state.oz + ' oz'));
          break;
        case 'kg':
          this.setgrams(Math.round(this.state.kg*1000));
          this.setlbs(Math.floor(1*this.state.grams / gPerLb));
          this.setoz(Math.round(16*this.state.grams / gPerLb % 16));
          this.props.dispatch(updateFillAnswer(this.state.kg + ' Kg'));
          break;
        case 'grams':
          this.setkg(this.state.grams/1000);
          this.setlbs(Math.floor(1*this.state.grams / gPerLb));
          this.setoz(Math.round(16*this.state.grams / gPerLb % 16));
          this.props.dispatch(updateFillAnswer(this.state.grams + ' grams'));
      }
      this.props.dispatch(updateFillValue(this.state.grams));
      this.props.dispatch(setWeightData(this.state))
    }
  }
  componentWillUnmount() {

  }
  setgrams = (value) => {
    this.setState((state) => {
      return {
        grams: value
      }
    })
  }
  setkg = (value) => {
    this.setState((state) => {
      return {
        kg: value
      }
    })
  }
  setlbs = (value) => {
    this.setState((state) => {
      return {
        lbs: value
      }
    })
  }
  setoz = (value) => {
    this.setState((state) => {
      return {
        oz: value
      }
    })
  }

  handlegrams = (event) => {
    this.setState((state) => {
      return {
        grams: event.target.value
      }
    })
  }
  handlekg = (event) => {
    this.setState((state) => {
      return {
        kg: event.target.value
      }
    })
  }
  handlelbs = (event) => {
    this.setState((state) => {
      return {
        lbs: event.target.value
      }
    })
  }
  handleoz = (event) => {
    this.setState((state) => {
      return {
        oz: event.target.value
      }
    })
  }


  render() {
    var { answers } = this.props

    return(
      <div className="single-select-textbox-second-container">
        <div className="single-select-textbox-second-select">
          <select readOnly data-placeholder="Select" className="chosen-select-no-single" name="xmp-answer">
            <option className="title">Select</option>
            <option value="imperial">Lbs, Oz</option>
            <option value="kg">KG</option>
            <option value="grams">Grams</option>
          </select>
        </div>
        <div className="single-select-textbox-second-input">
          {(this.state.units == 'imperial') ? (<div>
            <input type="text" placeholder="Lbs" onChange={this.handlelbs} value={this.state.lbs} className="single-select-textbox-second-textbox"/>
              <input type="text" placeholder="Oz" onChange={this.handleoz} value={this.state.oz} className="single-select-textbox-second-textbox"/>
          </div>) : null}
          {(this.state.units == 'kg') ? (<div>
            <input type="text" placeholder="KG" onChange={this.handlekg} value={this.state.kg} className="single-select-textbox-second-textbox"/>
          </div>) : null}
          {(this.state.units == 'grams') ? (<div>
            <input type="text" placeholder="Grams" onChange={this.handlegrams} value={this.state.grams} className="single-select-textbox-second-textbox"/>
          </div>) : null}
        </div>
      </div>
    )
  }
}
const Container = connect(() => {return {}})(Weight);

export default Container;





// WEBPACK FOOTER //
// ./src/components/Weight.js